import * as React from 'react';
import PriceChartEventLabelText from './PriceChartEventLabelText';
import { useTheme } from '@simplywallst/ui-core';
import type { Category } from '../../query';
import { getCategoryColor } from '../../utils/getCategoryColor';

interface Props {
  category: Category;
  date: number;
  id: string;
  onClick?: (data: { id: string; date: number }) => void;
  onLabelUpdate: (date: number, width: number) => void;
  shortName: string;
  visibility: 'visible' | 'hidden';
  y: number;
}

export function PriceChartEventLabel(props: Props) {
  const theme = useTheme();
  const { y, category, visibility, shortName, date, onLabelUpdate } = props;
  const [width, setWidth] = React.useState(0);
  const padding = 8;

  const handleWidthUpdate = React.useCallback(
    (width: number) => {
      onLabelUpdate(date, width);
      setWidth(width);
    },
    [date, onLabelUpdate]
  );

  function handleClick() {
    const { id, date, onClick } = props;
    if (typeof onClick === 'function') {
      onClick({
        id,
        date,
      });
    }
  }
  return (
    <g
      transform={`translate(0, ${y})`}
      visibility={visibility}
      data-cy-id={`price-chart-event-label-${props.id}`}
    >
      <rect
        x={-(width + padding)}
        y="-4"
        width={width + padding}
        height="20"
        fill="#1f2a35"
        rx="2"
        ry="2"
      />
      <rect x="-1" y="-30" width="1" height="30" fill="#1f2a35" />
      <rect
        x={0}
        y="-4"
        fill={theme.color[getCategoryColor(category)]}
        width="2"
        height="20"
      />
      <path d={`M0 0 L0 -8 L-4 -4 z`} fill="#1F2A35" />
      <PriceChartEventLabelText x={-4} handleWidthUpdate={handleWidthUpdate}>
        {shortName}
      </PriceChartEventLabelText>
      <rect
        x={-(width + padding)}
        y="-4"
        width={width + padding}
        height="20"
        fill="transparent"
        onClick={handleClick}
        cursor="pointer"
      />
    </g>
  );
}
